import { FC } from "react";
import { IconProps } from "./types";

export const CheckMark: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="m9.967 17.692-4.753-4.753a.731.731 0 0 1 0-1.034l1.034-1.035a.731.731 0 0 1 1.034 0l3.202 3.202 6.859-6.858a.731.731 0 0 1 1.034 0l1.034 1.034a.731.731 0 0 1 0 1.034L11 17.692a.731.731 0 0 1-1.034 0z"
      fill={fill}
    />
  </svg>
);
